/*
Sohel  09/22/2022   2699250881  Custom Windows Feedback Modifications
Sohel  09/23/2022   2699250881  Fixed Custom Windows Feedback Changes
Sohel  09/26/2022   2699250881  Added Window Owner Field, columns to dashboard table,bugfixes.
Ashraf 09/30/2022   2699250881  fixed global payload issues
Ashraf 10/01/2022   2699250881  fixed custom window bugs
Sohel  10/03/2022   2699250881  Fixed GAL-348 and Custom Windows Catagory added LooK UP API
Sohel  10/03/2022   2699250881  Table Name Value not display issue
Ashraf 10/15/2022   2699250881  Added custom windows code comments
Suresh Peddavoora 10/28/2022 2699250881  Added Class Name for Text Fields and Buttons
*/
import React, {useState, useContext, useEffect} from 'react';
import {Formik} from 'formik';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import SearchDatabaseReferenceTable from './SearchDatabaseReferenceTable';
import {useDispatch, useSelector} from 'react-redux';
import * as Yup from 'yup';
import PageLoader from './../../../PageLoader/index';
import {
  getTableName,
  getTableFieldName,
} from '../../../../redux/reducers/GlobalField/GlobalField';
import {getBaseCategory} from '../../../../redux/reducers/GlobalField/AddFieldList';
import GuiAutoComplete from '../../../FormComponents/GuiAutoComplete';
import GuiTextField from '../../../FormComponents/GuiTextField';

// search global field form (2700768219)
const SearchFields = ({setDataBaseValue, handleClose}) => {
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const {baseCategoryData} = useSelector(({addFieldList}) => addFieldList);
  const dispatch = useDispatch();

  const {tableNameData, tableFieldNameData, isLoading} = useSelector(
    ({globalField}) => globalField,
  );
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  // validation for fields (2700768219)
  const schema = Yup.object().shape({
    globalField: Yup.string().matches(
      /^[a-zA-Z0-9]+$/,
      'White space and special character are not allowed',
    ),
  });

  // initial form values (2700768219)
  const initialValues = {
    category: '',
    displayName: '',
    globalField: '',
    description: '',
    tableName: '',
    tableFieldName: '',
    groupCode: '',
  };

  // search data submit (2700768219)
  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };

  // reset initial values (2700768219)
  const onClear = () => {
    const data = {
      category: '',
      displayName: '',
      globalField: '',
      description: '',
      tableName: '',
      tableFieldName: '',
      groupCode: '',
    };
    setSearchData(data);
  };

  // fetch category dropdown options (2700768219)
  useEffect(() => {
    dispatch(getBaseCategory());
  }, []);

  return (
    <div className={classes.dialoguecardStyles}>
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleSubmit,
              handleReset,
              handleBlur,
              setFieldValue,
              touched,
              resetForm,
              errors,
            } = props;

            return (
              <div>
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div>
                    <ErrorBoundaryForComponents>
                      <div className="form-row global-field-textfields">
                        <div className="col-xs-6 col-sm-6 col-md-4 col-xl-4 col-lg-4 form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="category"
                            id="category"
                            size="small"
                            value={values.category}
                            options={baseCategoryData}
                            getOptionLabel={(option) => {
                              return option && option?.categoryName ?
                                option?.categoryCode === null ?
                                  option?.categoryName :
                                  option?.categoryCode + ' - ' + option?.categoryName :
                                '';
                            }}
                            required
                            onChange={(e, value) => {
                              if (value) {
                                setFieldValue('category', value);
                                dispatch(getTableName(value?.categoryCode));
                                setFieldValue('tableName', '');
                                setFieldValue('tableFieldName', '');
                              } else {
                                setFieldValue('category', '');
                              }
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  error={touched.category && errors.category}
                                  variant="outlined"
                                  margin="dense"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  label="Category"
                                  className={` ${classes.labelName} ${classes.selectLabel}`}
                                  placeholder="Select Category"
                                />
                              </div>
                            )}
                          />
                          <FormHelperText>
                            {touched.category && errors.category && errors.category}
                          </FormHelperText>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-4 col-xl-4 col-lg-4 form-group">
                          <TextField
                            margin="dense"
                            className={`${classes.labelName} ${classes.inputLabel}`}
                            variant="outlined"
                            placeholder={`Enter Global Field Code`}
                            label="Global Field Code"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="globalField"
                            value={values?.globalField?.toUpperCase()}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.globalField}
                            error={Boolean(touched.globalField && errors.globalField)}
                          />
                          <FormHelperText>
                            {touched.globalField && errors.globalField && errors.globalField}
                          </FormHelperText>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-4 col-xl-4 col-lg-4 form-group">
                          <TextField
                            className={`${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder="Enter Global Field Description"
                            label="Global Field Description"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="description"
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-4 col-xl-4 col-lg-4 form-group">
                          <TextField
                            className={`${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder="Enter Group Code"
                            label="Group Code"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="groupCode"
                            value={values.groupCode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-4 col-xl-4 col-lg-4 form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                              listbox: classes.listBox,
                            }}
                            name="tableName"
                            id="tableName"
                            size="small"
                            value={values.tableName}
                            options={tableNameData}
                            required
                            disabled={!values?.category}
                            onChange={(e, value) => {
                              setFieldValue('tableFieldName', '');
                              if (value) {
                                setFieldValue('tableName', value);
                                dispatch(getTableFieldName(value));
                              } else {
                                setFieldValue('tableName', '');
                              }
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  className={`${classes.labelName} ${classes.selectLabel}`}
                                  error={touched.tableName && errors.tableName}
                                  variant="outlined"
                                  margin="dense"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  label="Table Name"
                                  placeholder="Select Table Name"
                                />
                              </div>
                            )}
                          />
                          <FormHelperText>
                            {touched.tableName && errors.tableName && errors.tableName}
                          </FormHelperText>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-4 col-xl-4 col-lg-4 form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                              listbox: classes.listBox,
                            }}
                            name="tableFieldName"
                            id="tableFieldName"
                            size="small"
                            value={values.tableFieldName}
                            options={tableFieldNameData}
                            required
                            disabled={!values?.tableName}
                            onChange={(e, value) => {
                              if (value) {
                                setFieldValue('tableFieldName', value);
                              } else {
                                setFieldValue('tableFieldName', '');
                              }
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={`${classes.labelName} ${classes.selectLabel}`}
                                  {...params}
                                  variant="outlined"
                                  margin="dense"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  label="Table Field Name"
                                  placeholder="Select Table Field Name"
                                  error={touched.tableFieldName && errors.tableFieldName}
                                />
                              </div>
                            )}
                          />
                          <FormHelperText>
                            {touched.tableFieldName &&
                              errors.tableFieldName &&
                              errors.tableFieldName}
                          </FormHelperText>
                        </div>

                      </div>
                    </ErrorBoundaryForComponents>
                  </div>
                  <div className="button-table-spacing-mb">
                    <Button
                      variant="outlined"
                      type="button"
                      onClick={() => {
                        setSubmit(true);
                        resetForm();
                        onClear();
                      }}
                      className={`reset-btn mx-1`}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="outlined"
                      className={`search-btn mx-1`}
                      type="submit"
                    >
                      <span>Search</span>
                    </Button>
                  </div>
                </form>
              </div>
            );
          }}
        </Formik>
      </div>
      <SearchDatabaseReferenceTable
        searchData={searchData}
        setDataBaseValue={setDataBaseValue}
        handleClose={handleClose}
        submit={submit}
        setSubmit={setSubmit}
      />
      {isLoading && <PageLoader />}
    </div>
  );
};

export default SearchFields;
